"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AuthUserConsumer", {
  enumerable: true,
  get: function get() {
    return _authUser.AuthUserConsumer;
  }
});
Object.defineProperty(exports, "AuthUserProvider", {
  enumerable: true,
  get: function get() {
    return _authUser.AuthUserProvider;
  }
});
Object.defineProperty(exports, "AuthUserContext", {
  enumerable: true,
  get: function get() {
    return _authUser["default"];
  }
});
Object.defineProperty(exports, "LanguageContext", {
  enumerable: true,
  get: function get() {
    return _language["default"];
  }
});
Object.defineProperty(exports, "SnackbarContext", {
  enumerable: true,
  get: function get() {
    return _snackbar.SnackbarContext;
  }
});
Object.defineProperty(exports, "SnackbarProvider", {
  enumerable: true,
  get: function get() {
    return _snackbar.SnackbarProvider;
  }
});

var _authUser = _interopRequireWildcard(require("./authUser.context"));

var _language = _interopRequireDefault(require("./language.context"));

var _snackbar = require("./snackbar.context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }